import { fetchBySlugs } from 'Redux/ducks/algolia-calls';
import { getPersistedRecentlyViewedSlugs } from 'Api/RecentlyViewed/utility';

/**
 * Fetches recently viewed items from algolia
 * @param hitsToDisplay the amount of hits to fetch in algolia call
 * @param slugsToExclude slugs we wish to exclude from recentlyViewed
 * @return {Function} recentlyViewedHits to dispatch
 */
export default async function fetchRecentlyViewed(hitsToDisplay, slugsToExclude) {
  let recentlyViewedSlugs = getPersistedRecentlyViewedSlugs();

  if (Array.isArray(slugsToExclude) && slugsToExclude.length > 0) {
    recentlyViewedSlugs = recentlyViewedSlugs.filter(slug => !slugsToExclude.includes(slug));
  }

  const recentlyViewedHits = await fetchBySlugs([recentlyViewedSlugs.slice(0, hitsToDisplay)]);
  return recentlyViewedHits[0];
}
